module.exports = __webpack_public_path__ + "img/ios-share-icon.71644fe6.svg";